// SiteUp: a lista (index/filter) manda o payload enxuto da conversa:
// custom_attributes vazio, additional_attributes fatiado e sem o bloco de IA
// completo. Só o SHOW traz ai_agent_followup (sempre um objeto), então ele serve
// de marcador de "payload completo". Não usar ai_agent_mode: desde o #783 a
// lista também manda esse campo e o SHOW deixou de sair ao abrir a conversa.
export const hasFullConversationPayload = chat =>
  Boolean(chat) && chat.ai_agent_followup !== undefined;

export const needsConversationShowFetch = chat =>
  !hasFullConversationPayload(chat);
